<template>
  <div class="user-wapper " v-if="isAdminUser()">
      <b-card-title>Buscador de Usuario</b-card-title>
    <hr>
    <b-input-group size="sm">
      <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Escriba para buscar...">
      </b-form-input>
    </b-input-group>
    <b-table responsive="sm" class="mt-3 text-center" small hover stacked="md" :items="items" :fields="computedFields"
      :busy="isBusy" :current-page="currentPage" :per-page="perPage" :filter="filter" @filtered="onFiltered">
      <template v-slot:cell(FeeNom)="data">
        <div class="d-flex justify-content-start">
          <div class="chart mr-2">
            <div class="bar" style="height: 20%;" :class="applyBarClasses(data.value).bar1"></div>
            <div class="bar" style="height: 40%;" :class="applyBarClasses(data.value).bar2"></div>
            <div class="bar" style="height: 60%;" :class="applyBarClasses(data.value).bar3"></div>
            <div class="bar" style="height: 80%;" :class="applyBarClasses(data.value).bar4"></div>
          </div>
          <span>{{ data.value }}</span>
        </div>

      </template>
      <template v-slot:cell(IsVerify)="data">
        <div class="d-flex justify-content-start  ">
          <b-icon :icon="data.value ? 'person-check-fill' : 'person-x-fill'"
            :variant="data.value ? 'success' : 'danger'" />
        </div>
      </template>
      <template v-slot:cell(Blockchain)="data">
        <div class="d-flex justify-content-start ">
          <b-icon :icon="data.value ? 'check-circle-fill' : 'x-circle-fill'"
            :variant="data.value ? 'success' : 'danger'" />
        </div>
      </template>
      <template #cell(show_details)="row">
        <cid-button size="sm" @click="row.toggleDetails" class="mr-2">
          {{ row.detailsShowing ? 'Ocultar' : 'Mostrar' }} Detalles
        </cid-button>
      </template>

      <template #row-details="row">
        <user-data-action :row="row" @update-row="updateRow" @delete-row="deleteRow">

        </user-data-action>
      </template>
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-1"></b-spinner>
          <strong>Cargando...</strong>
        </div>
      </template>
    </b-table>

    <b-row v-if="items.length" class="justify-content-end mt-4 mb-2">
      <b-col md="3" lg="2" xl="3" class="table_pagination">
        <b-pagination v-model="currentPage" pills prev-text="Anterior" next-text="Siguiente" :total-rows="totalRows"
          :per-page="perPage" size="sm" class="my-0" first-number last-number>
        </b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios';
import UserDataAction from './UserDataAction.vue';
export default {
  name: 'user-dashboard',
  components: {
    UserDataAction
  },
  data() {
    return {
      items: [],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      isBusy: true,
      filter: null,
      User:undefined
    }
  },
  computed: {
    computedFields() {
      return [
        { key: 'FullName', label: 'Nombre', sortable: true, formatter: this.formatFullName },
        { key: 'Email', label: 'Correo electrónico', sortable: true },
        { key: 'FeeNom', label: 'Tipo de Cuenta', sortable: true },
        { key: 'IsVerify', label: 'Usuario Verificado', sortable: true },
        { key: 'Blockchain', label: 'Blockchain', sortable: true },
        { key: 'show_details', label: 'Ver detalles', class: 'text-center' },
      ];
    },
  },
  created() {
    this.User = this.$store.state.userRole;
    this.loadData();
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async loadData() {
      try {
        const response = await axios.get('/api/Account/GetAllUsers/')
        this.items = response.data;

        const filledEntries = this.items.filter(entry => {
          const dni = entry.Dni;
          const name = entry.Name;
          const surname = entry.Surname;

          return dni !== "" && name !== "" && surname !== "" && dni !== name && dni !== surname && name !== surname;
        });

        this.items = filledEntries;
        this.totalRows = filledEntries.length;

      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    updateRow(newRow) {
      // Obtener el índice de la fila en el array "oldRow"
      const rowIndex = this.items.findIndex(item => item.aId === newRow.aId);
      // Reemplazar la newRow en el array "items"
      if (rowIndex !== -1) {
        this.items.splice(rowIndex, 1, newRow);
      }
      this.$bvToast.toast("Se ha actualizado correctamente la información del usuario", {
        title: 'Enhorabuena',
        variant: 'info'
      });

    },
    deleteRow(row) {
      // Lógica para eliminar los datos correspondientes en el componente padre
      const rowIndex = this.items.findIndex(item => item.aId === row.aId);
      if (rowIndex !== -1) {
        this.items.splice(rowIndex, 1);
      }
      this.$bvToast.toast("eliminado", {
        title: 'Ejemplo',
        variant: 'info'
      });
      this.totalRows = this.items.length;
    },
    formatFullName(value, key, item) {
      return `${item.Name} ${item.Surname}`;
    },
    applyBarClasses(value) {
      const classes = {
        bar1: 'bg-secondary',
        bar2: 'bg-secondary',
        bar3: 'bg-secondary',
        bar4: 'bg-secondary'
      };

      const index = ['Basic', 'Medium', 'High', 'Premium'].indexOf(value);
      if (index >= 0) {
        for (let i = 0; i <= index; i++) {
          classes['bar' + (i + 1)] = 'bg-success';
        }
      }

      return classes;
    },
    isAdminUser() {
      return this.User == 'Admin';
    },


  }

}
</script>



<style scoped>
.user-wapper {
  margin: 10px;
  padding: 25px 15px;

  background: #ffffff;
  /* Agrega las propiedades adicionales necesarias a continuación */
  color: #333333;
  border: 1px solid #dddddd;
  border-radius: 4px;
  /* ... */
}

.file-iconstack {
  margin: 0;
}

.file-iconstack .b-icon {
  margin-right: 4px;
  /* Espaciado entre los iconos */
  width: 0.5em;
}

.chart {
  display: flex;
  width: 40px;
  height: 20px;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-end;
}

.bar {
  width: 100%;
  border-radius: 1.5px 1.5px 0px 0px;
  margin-right: 5px;
}

.bar:last-child {
  margin-right: 0;
}
</style>